import axios from "axios";
import { store } from "../../../Aplicaciones/Masters/Store/store.js";
import router from "../../../router";
const SesionExpirada = () =>
  Boolean(window.sessionStorage.getItem("Token") == null);

function CerrarSesion() {
  axios.defaults.headers.common["Authorization"] = null;
  //Destruir el token de la sesión
  sessionStorage.removeItem("Token");
  //Limpiar Vuex Store
  store.commit("setSesionActiva", false);
  store.commit("setUsuario", null);
  store.commit("setTipoUsuario", null);
  store.commit("setProspecto", null);
  store.commit("setModoPago", null);
  store.commit("setSolicitudFisica", null);
  store.commit("setSolicitudExtranjera", null);
  store.commit("setSolicitudMoral", null);
  store.commit("setProspectoRepresentanteLegal", null);
  store.commit("setSolicitudRepresentante", null);
  window.sessionStorage.removeItem("nombreUsuario");
  window.sessionStorage.removeItem("apellidoUsuario");
  window.sessionStorage.removeItem("tipoUsuario");
  window.sessionStorage.removeItem("tipoPersona");
  router.push({
    name: "LoginMaster"
  });
}

function OnboardingOnProgress(value){
  store.commit(
    "setOnboardingOnProgress",
    value
  );
}

function esExtranjero(tipoPersona) {
  switch (tipoPersona) {
      case 2:
      case 5:
      case 7:
          return true;
      default:
          return false;
  }
}

function PerfilTieneAccesoAExpediente(usuario){
  let tieneAcceso = false;
  if(usuario == 1 || usuario == 3 || usuario == 4 || usuario == 6 || usuario == 8 || usuario == 9 || usuario == 10) tieneAcceso = true;
  return tieneAcceso;
}
function PerfilTieneAccesoADocumentos(usuario){
  let tieneAcceso = false;
  if(usuario == 1 || usuario == 3 || usuario == 4 || usuario == 6 || usuario == 8 || usuario == 9 || usuario == 10) tieneAcceso = true;
  return tieneAcceso;
}
function PerfilTieneAccesoABuro(usuario){
  let tieneAcceso = false;
  if(usuario == 1 || usuario == 3 || usuario == 6 || usuario == 8 || usuario == 9) tieneAcceso = true;
  return tieneAcceso;
}

function DarFormatoMoneda(monto) {
  var montoFormateado = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN"
  }).format(monto);

  return montoFormateado;
}
function DarFormatoFecha(fecha) {
  var date = fecha,
    current_date = date.getDate(),
    current_month = date.getMonth() + 1,
    current_year = date.getFullYear(),
    current_hrs = date.getHours(),
    current_mins = date.getMinutes(),
    current_secs = date.getSeconds(),
    fechaConFormato;

  current_date = current_date < 10 ? "0" + current_date : current_date;
  current_month = current_month < 10 ? "0" + current_month : current_month;
  current_hrs = current_hrs < 10 ? "0" + current_hrs : current_hrs;
  current_mins = current_mins < 10 ? "0" + current_mins : current_mins;
  current_secs = current_secs < 10 ? "0" + current_secs : current_secs;

  fechaConFormato =
    current_year +
    "-" +
    current_month +
    "-" +
    current_date +
    "T" +
    current_hrs +
    ":" +
    current_mins +
    ":" +
    current_secs;
  return fechaConFormato;
}

//Esta función regresa una cadena con la respuesta de acuerdo a ENUM ingresado.
function RespuestasValidacionEvento(respuesta) {
  switch (respuesta) {
    case 0:
      return "Ya existe una llamada agendada en ese horario.";
    case 1:
      return "Ya existe una cita agendada en ese horario.";
    default:
      break;
  }
}

//Esta función evita ingresar números negativos a inputs de tipo numéricos, solo funciona con números enteros.
function EvitarNegativos(campo) {
  var valor;
  if (campo != "" || campo != null) {
    if (parseInt(campo) < 1) {
      valor = campo * -1;
    } else {
      valor = campo;
    }
    return valor;
  } else {
    return null;
  }
}

//Esta función limita la cantidad de dígitos ingresados en un input para números de telefono locales (MX)
function LimitarTelefonoLocal(telefono) {
  if (telefono != null) {
    let numero = telefono.toString();
    if (numero.length > 10) {
      return numero.substring(0, numero.length - 1);
    } else {
      return telefono;
    }
  }
}

function validarFormatoArchivoValido(archivo) {
  //valida si cumple con el formato
  if (
    archivo.type !== "image/jpeg" &&
    archivo.type !== "image/png" &&
    archivo.type !== "application/pdf" &&
    archivo.type !==
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
    archivo.type !== "application/msword" &&
    archivo.type !==
      "application/vnd.openxmlformats-officedocument.presentationml.presentation" &&
    archivo.type !== "application/vnd.ms-powerpoint" &&
    archivo.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
    archivo.type !== "application/vnd.ms-excel"
  )
    return false;

  return true;
}

function validarTamanioArchivoValido(archivo) {
  if (parseInt(archivo.size) >= parseInt(41943040)) return false;

  return true;
}

function EsMayorDeEdad(fechaNacimiento) {
  let hoy = new Date();
  const _fechaNac = new Date(fechaNacimiento);
  let anios = hoy.getYear() - _fechaNac.getYear();

  if (anios > 18) {
    return true;
  } else if (anios == 18) {
    if (hoy.getUTCMonth() < _fechaNac.getUTCMonth()) {
      return false;
    } else if (hoy.getUTCMonth() > _fechaNac.getUTCMonth()) {
      return true;
    } else if (hoy.getUTCMonth() == _fechaNac.getUTCMonth()) {
      return hoy.getUTCDate() > _fechaNac.getUTCDate() ? true : false;
    }
  } else if (anios < 18) {
    return false;
  }
}

//Obtener el texto de acuerdo a INT de relación para referencias personales y beneficiarios.
function ObtenerStringRelacion(relacion) {
  switch (relacion) {
    case 0:
      return "Conyuge";
    case 1:
      return "Concubino(a)";
    case 2:
      return "Madre";
    case 3:
      return "Padre";
    case 4:
      return "Hermano(a)";
    case 5:
      return "Hijo(a)";
    case 6:
      return "Abuelo(a)";
    case 7:
      return "Nieto(a)";
    case 8:
      return "Tío(a)";
    case 9:
      return "Sobrino(a)";
    case 10:
      return "Primo(a)";
    default:
      break;
  }
}
//En inglés
function ObtenerStringRelacionIngles(relacion) {
  switch (relacion) {
    case 0:
      return "Spouse";
    case 1:
      return "Concubine";
    case 2:
      return "Mother";
    case 3:
      return "Father";
    case 4:
      return "Sibling";
    case 5:
      return "Son or daugther";
    case 6:
      return "Grandfather or grandmother";
    case 7:
      return "Grandchild";
    case 8:
      return "Uncle or aunt";
    case 9:
      return "Nephew or niece";
    case 10:
      return "Cousin";
    default:
      break;
  }
}
//Mensaje redirección pantalla
function CrearMensaje(tipoUsuario, tipoPersona, pantalla) {
  switch (pantalla) {
    case "SeguimientoProspecto":
      if (tipoUsuario == 3) {
        //return tipoPersona != 4 || tipoPersona != 6
        return (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
          ? "Haz completado tu proceso, pronto recibirás noticias."
          : "You have completed your process, you will receive news soon.";
      } else {
        return "El prospecto a completado su proceso como Cotitular y/o Obligado Solidario, pronto recibirás noticias.";
      }
    case "PreAutorizacion":
      if (tipoUsuario == 3) {
        return (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
          ? "El proceso se encuentra en pre autorización, pronto recibirás noticias."
          : "The process is in pre-authorization, you will receive news soon.";
      } else {
        return "El proceso se encuentra en pre autorización, pronto recibirás noticias.";
      }
    case "GenerarInformacionDePago":
      if (tipoUsuario == 3) {
        return (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
          ? "El proceso se encuentra en la generación de información de pago, pronto recibirás noticias."
          : "The process is in the stage of generating payment information, you will receive news soon.";
      } else {
        return "El proceso se encuentra en la generación de información de pago, pronto recibirás noticias.";
      }
    case "ValidarPago":
      if (tipoUsuario == 3) {
        return (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
          ? "El proceso se encuentra en validación de pago, pronto recibirás noticias."
          : "The process is in payment validation, you will receive news soon.";
      } else {
        return "El proceso se encuentra en validación de pago, pronto recibirás noticias.";
      }
    case "CargarInformacionDePago":
      return "El prospecto se encuentra realizando su pago, pronto recibirás noticias.";
    case "CajaDorada":
      if (tipoUsuario == 3) {
        return (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)
          ? "El prospecto ya se encuentra contratado y tiene acceso a su Kit de Bienvenida."
          : "The prospect is already contracted and has access to the golden box.";
      } else {
        return "El prospecto ya se encuentra contratado y tiene acceso a su Kit de Bienvenida.";
      }
  }
}

function ObtenerMesesDelAnioParaDropDown(){
  return [
    {
        value: 1,
        text: "Enero"
    },
    {
        value: 2,
        text: "Febrero"
    },
    {
        value: 3,
        text: "Marzo"
    },
    {
        value: 4,
        text: "Abril"
    },
    {
        value: 5,
        text: "Mayo"
    },
    {
        value: 6,
        text: "Junio"
    },
    {
        value: 7,
        text: "Julio"
    },
    {
        value: 8,
        text: "Agosto"
    },
    {
        value: 9,
        text: "Septiembre"
    },
    {
        value: 10,
        text: "Octubre"
    },
    {
        value: 11,
        text: "Noviembre"
    },
    {
        value: 12,
        text: "Diciembre"
    },
    {
        value: 13,
        text: "Ver todos"
    }
  ];
}

export default {
  DarFormatoFecha,
  DarFormatoMoneda,
  EvitarNegativos,
  LimitarTelefonoLocal,
  validarFormatoArchivoValido,
  validarTamanioArchivoValido,
  EsMayorDeEdad,
  RespuestasValidacionEvento,
  ObtenerStringRelacion,
  ObtenerStringRelacionIngles,
  SesionExpirada,
  CerrarSesion,
  CrearMensaje,
  PerfilTieneAccesoAExpediente,
  PerfilTieneAccesoADocumentos,
  PerfilTieneAccesoABuro,
  ObtenerMesesDelAnioParaDropDown,
  OnboardingOnProgress,
  esExtranjero
};
